import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import Placeholder from '../Placeholder';
import {formatBillingContact} from "components/billing/BillingItemList";
import {formatCurrency} from "utils/i18n";
import {BigNumber} from "bignumber.js";
import FontAwesome from 'react-fontawesome';
import LinkButton from 'components/LinkButton/LinkButton';

class AccountBalancesList extends React.Component {

  static propTypes = {
    billingAccountId: PropTypes.string.isRequired,
  };

  constructor() {
    super();

    this.state = {
      loading: true,
      itemAmounts: [],
      showBreakdown: false,
      breakdownLoading: false,
      breakdownAmounts: {}
    };
  }

  componentDidMount() {
    const {billingAccountId} = this.props;
    const token = $('meta[name="csrf-token"]').attr('content');
    fetch(`/api/billing_accounts/${billingAccountId}/balances`, {
      method: 'GET',
      headers: {'X-CSRF-Token': token},
      credentials: 'same-origin'
    }).then(response => {
      if (response.ok) {
        response.json().then(json => {
          this.setState({loading: false, itemAmounts: json.billing_item_balances})
        });
      }
    })
  }

  loadBreakdownAmounts(billingCategoryId, billingContactId) {
    const { billingAccountId } = this.props;
    const { breakdownAmounts, showBreakdown } = this.state;
    const token = $('meta[name="csrf-token"]').attr('content');
    const key = `${billingCategoryId}-${billingContactId}`;

    if (showBreakdown === key) {
      this.setState({ showBreakdown: false });
    } else if (breakdownAmounts[key]) {
      this.setState({ showBreakdown: key });
    } else {
      this.setState({ breakdownLoading: true });
      const params = {
        billing_category_id: billingCategoryId,
        billing_contact_id: billingContactId
      };
      fetch(`/api/billing_accounts/${billingAccountId}/balances?${queryString.stringify(params)}`, {
        method: 'GET',
        headers: { 'X-CSRF-Token': token },
        credentials: 'same-origin'
      }).then(resp => {
        if (resp.ok) {
          resp.json().then(json => {
            breakdownAmounts[key] = json.billing_item_balances;
            this.setState({
              breakdownLoading: false,
              showBreakdown: key,
              breakdownAmounts
            });
          });
        }
      });
    }

  }

  render() {
    const {
      loading,
      itemAmounts,
      showBreakdown,
      breakdownLoading,
      breakdownAmounts
    } = this.state;
    const total = itemAmounts.reduce((total, amount) => total.plus(new BigNumber(amount.amount)), new BigNumber(0));

    return <Placeholder.loading ready={!loading}>
      {itemAmounts.length === 0 && <p>
        <em>No balances found.</em>
      </p>}

      {itemAmounts.length > 0 && (
        <table className="table account-balances-list">
          <thead>
          <tr>
            <th>Category</th>
            <th>Student</th>
            <th className="account-balance">Balance</th>
          </tr>
          </thead>

          <tbody>
            {itemAmounts.map(amount => {
              const amountKey = `${amount.billing_category_id}-${amount.billing_contact_id}`;
              return (
                <React.Fragment key={amountKey}>
                  <tr>
                    <td>
                      <LinkButton
                        content={<FontAwesome name={showBreakdown === amountKey ? 'caret-down' : 'caret-right'} />}
                        onClick={() => this.loadBreakdownAmounts(amount.billing_category_id, amount.billing_contact_id)}
                      />
                      {amount.billing_category.name}
                    </td>
                    <td>{formatBillingContact(amount.billing_contact)}</td>
                    <td className={classNames('account-balance', { 'negative-number': amount.amount < 0 })}>
                      {formatCurrency(amount.amount)}
                    </td>
                  </tr>
                  {showBreakdown === amountKey && (
                    <tr>
                      <td colSpan='3'>
                        <div className='card bg-light'>
                          <Placeholder.loading ready={!breakdownLoading}>
                            <table className='table'>
                              <thead>
                              <tr>
                                <th>Category</th>
                                <th className='account-balance'>Amount</th>
                              </tr>
                              </thead>
                              <tbody>
                                {breakdownAmounts[amountKey].map(breakdown => (
                                  <tr key={`${breakdown.billing_category_id}-${breakdown.billing_contact_id}`}>
                                    <td>{breakdown.billing_category.name}</td>
                                    <td
                                      className={classNames(
                                        'account-balance', { 'negative-number': breakdown.amount < 0 }
                                      )}
                                    >
                                      {formatCurrency(breakdown.amount)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </Placeholder.loading>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>

          <tbody>
            <tr>
              <td colSpan='2'>Total</td>
              <td
                className={classNames(
                  'account-balance', { 'negative-number': total < 0 }
                )}
              >
                {formatCurrency(total.toFixed(2))}
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </Placeholder.loading>
  }
}

export default AccountBalancesList;
